module.exports = __webpack_public_path__ + "media/assets/icons/cards-outline-d2027fb0cff2ca2cbc936a78d27648c8.svg";